import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataSubjectDto } from '../types';
import { DataSubjectUrl } from './DataSubjectUrl';

const getDataSubject = ({ id }: { id: number }) =>
  apiClient
    .get<DataSubjectDto>(expand(DataSubjectUrl.DATASUBJECT, { id }))
    .then((response) => response.data);

export const useDataSubjectQuery = createApiQueryHook(
  ['dataSubject'],
  getDataSubject
);
